// extracted by mini-css-extract-plugin
export default {"saleBannerText":"SQHZgJ","urgencyDash":"Mk6JLd","urgencyTimer":"XXswBV"};